'use client';
import React from 'react';
import Link from 'next/link';
import { ResourceCategoryWithResource } from '@dr-pam/common-components/Services/Server/ResourceService';
import { IconFileDownload } from '@tabler/icons-react';

interface ResourceListProps {
	resources?: ResourceCategoryWithResource[];
}

export default function ResourceList({ resources }: ResourceListProps) {
	if (!resources || resources.length === 0) {
		return null;
	}

	return (
		<ul className="title">
			{resources.map((resourceCategory) => (
				<li className="results-list" key={resourceCategory.id}>
					<IconFileDownload size={26} />
					<Link
						href={resourceCategory.resource.url}
						target="_blank"
						rel="noopener noreferrer"
						className="no-after"
					>
						{resourceCategory.resource.title}
					</Link>
				</li>
			))}
		</ul>
	);
}
